import { render, staticRenderFns } from "./CartHistoryModal.vue?vue&type=template&id=6104c832&"
import script from "./CartHistoryModal.vue?vue&type=script&lang=js&"
export * from "./CartHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports